import type { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '../composables/useAuth'

// Lazy load components for better performance
const Dashboard = () => import('../views/Dashboard.vue')
const Benchmark = () => import('../views/Benchmark.vue')
const Comparative = () => import('../views/Comparative.vue')
const ComparativeReport = () => import('../views/ComparativeReport.vue')
const Rollup = () => import('../views/Rollup.vue')
const RollupReport = () => import('../views/RollupReport.vue')

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
      title: 'Dashboard',
      icon: 'pi pi-chart-line',
    },
  },
  {
    path: '/benchmark',
    name: 'Benchmark',
    component: Benchmark,
    meta: {
      requiresAuth: true,
      title: 'Benchmark Reporting',
      icon: 'pi pi-flag',
    },
  },
  {
    path: '/comparative',
    name: 'Comparative',
    component: Comparative,
    meta: {
      requiresAuth: true,
      title: 'Comparative Reporting',
      icon: 'pi pi-table',
    },
  },

  {
    path: '/comparative/:reportName',
    name: 'ComparativeReport',
    component: ComparativeReport,
    meta: {
      requiresAuth: true,
      title: 'Comparative Report',
      icon: 'pi pi-table',
    },
  },
  {
    path: '/rollup',
    name: 'Rollup',
    component: Rollup,
    meta: {
      requiresAuth: true,
      title: 'Roll-up Reporting',
      icon: 'pi pi-chart-bar',
    },
  },
  {
    path: '/rollup/:reportName',
    name: 'RollupReport',
    component: RollupReport,
    meta: {
      requiresAuth: true,
      title: 'Report',
      icon: 'pi pi-chart-bar',
    },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to: any, _from: any, next: any) => {
  if (to.matched.some((record: any) => record.meta.requiresAuth)) {
    const auth = useAuth()

    try {
      // checkAuthAndRedirect handles redirection internally and throws on auth failure
      await auth.checkAuthAndRedirect()
      // If we get here, authentication succeeded
      next()
    } catch (error) {
      // Authentication failed, checkAuthAndRedirect will handle redirection
      // Cancel the navigation
      next(false)
    }
  } else {
    next()
  }
})

export default router
